/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Event_Trigger_Filter_HintInputs */



/**
* | output |
* | --- |
* | "Leave empty to run on every event. Each pair must match a field of the event exactly." |
*
* @param {Agent_Event_Trigger_Filter_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_event_trigger_filter_hint = /** @type {((inputs?: Agent_Event_Trigger_Filter_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Event_Trigger_Filter_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Leer lassen, um bei jedem Ereignis auszuführen. Jedes Paar muss einem Feld des Ereignisses genau entsprechen.")
	return /** @type {LocalizedString} */ ("Leave empty to run on every event. Each pair must match a field of the event exactly.")
});